import { injectable } from "@launchtray/tsyringe-async";
import { Bindable } from "../../../../../shared/bindable-data";
import { IPaymentProcessingModel } from "./IPaymentProcessingModel";
import { PaymentResult } from "../../../../../web3/PaymentResult";
import { Web3Model } from "../../../../../web3/models/Web3Model";
import { Chain } from "thirdweb/chains";

@injectable()
export class PaymentProcessingModel extends Bindable implements IPaymentProcessingModel {
    public constructor(
        private readonly web3Model: Web3Model
    ) {
        super();
    }

    public async purchaseBuildingWithCrypto(chain: Chain, buildingId: string, couponBenefitIds?: Array<string>): Promise<PaymentResult> {
        return await this.web3Model.purchaseBuildingWithCrypto(chain, buildingId, couponBenefitIds);
    }

    public async buyBuildingThroughReservoir(orderId: string): Promise<PaymentResult> {
        return await this.web3Model.buyBuildingThroughReservoir(orderId);
    }

    public async erc20StorePayment(chain: Chain, erc20Address: string, tokenId: string, price: number): Promise<PaymentResult> {
        return await this.web3Model.erc20StorePayment(chain, erc20Address, tokenId, price);
    }
}
